import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { LkpBanksModel } from 'src/app/models/LkpBanksModel';
import { LkpBanksService } from 'src/app/services/LkpBanksService';


@Component({
  selector: 'app-bank-search',
  templateUrl: './bank-search.component.html',
  styleUrls: ['./bank-search.component.css']
})
export class BankSearchComponent implements OnInit {
  bnkCode='';
  bnkName ='';
  compCode = '1';
  BankList: LkpBanksModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();
  constructor(  public bank: LkpBanksModel,
    public bankService : LkpBanksService,
    public storage: LocalStorageService,
    public dialogRef: MatDialogRef<BankSearchComponent>,
    @Inject(MAT_DIALOG_DATA)
    public bankSelectedData: LkpBanksModel) { }

  ngOnInit(): void {
    this. retriveBankLookupTop();
}
retriveBankLookupTop() {

this.BankList = [];
this.bankService.getBankLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: LkpBanksModel[]) => {
  for (let i = 0; i < data.length; i++) {
    this.BankList[i] = data[i];
  }

})
}
SelectBank(bank: LkpBanksModel){                              ///----------- for searching pop up send variables from table-----------

  this.bankSelectedData.bnkcode = bank.bnkcode
  this.bankSelectedData.bnkname = bank.bnkname
  this.bankSelectedData.bnknotes =bank.bnknotes
  this.bankSelectedData.bnkaccount = bank.bnkaccount;
  this.bankSelectedData.bankopentype = bank.bankopentype;
  this.bankSelectedData.bnkDefult = bank.bnkDefult;
  this.bankSelectedData.bnkcurrency = bank.bnkcurrency;
  this.bankSelectedData.bnkopenbalance = bank.bnkopenbalance;
  this.bankSelectedData.bnkrate = bank.bnkrate;

  this.submitClicked.emit(this.bankSelectedData);
  this.dialogRef.close();
}

}
